import { render } from "./changeLimit.vue?vue&type=template&id=91bf1ece"
import script from "./changeLimit.vue?vue&type=script&lang=js"
export * from "./changeLimit.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__